module.exports = __webpack_public_path__ + "img/logo.6e11bc5b.png";